import { render } from "./CurrentSolutions.vue?vue&type=template&id=53adebdd&scoped=true&ts=true"
import script from "./CurrentSolutions.vue?vue&type=script&lang=ts"
export * from "./CurrentSolutions.vue?vue&type=script&lang=ts"

import "./CurrentSolutions.vue?vue&type=style&index=0&id=53adebdd&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53adebdd"]])

export default __exports__